/* eslint-disable max-params */
import BaseController from "@/attributes/BaseController";
import dayjs, { Dayjs } from "dayjs";
import { isFocusEnv } from "@/utils";

class CalendarController extends BaseController {
  getOfflineCalendar(propertyKey: string, args: any) {
    // 网页版不支持离线，如果是网页版直接return
    if (!isFocusEnv()) return;
    // 判断是否存在本地数据库，没有则return
    let key = "";
    switch (propertyKey) {
      case "calendar.getNewScheduleList":
        key = dayjs(args.beginDate).format("YYYYMMDD");
        break;
      case "calendar.getScheduleInfo":
        key = args.scheduleId;
        break;
      case "calendar.getMultipleCalendar":
        key = args.calendarIds.join();
        break;
      default:
        key = propertyKey;
    }
    return new Promise((resolve, reject) => {
      if (!this.dbService.dbService) {
        resolve(null);
        return;
      }
      this.dbService.dbService
        .getFromDB(key)
        .then((doc: any) => {
          resolve(doc?.content);
        })
        .catch((e: any) => {
          console.error(e);
          reject(e);
        });
    });
  }
  setOfflineCalendar(propertyKey: string, data: any, args: any) {
    // 网页版不支持离线，如果是网页版直接return
    if (!isFocusEnv()) return;
    // 判断是否存在本地数据库，没有则创建
    let key = "";
    switch (propertyKey) {
      case "calendar.getNewScheduleList":
        key = dayjs(args.beginDate).format("YYYYMMDD");
        break;
      case "calendar.getScheduleInfo":
        key = args.scheduleId;
        break;
      case "calendar.getMultipleCalendar":
        key = args.calendarIds.join();
        break;
      default:
        key = propertyKey;
    }

    return new Promise((resolve, reject) => {
      if (!this.dbService.dbService) {
        resolve(null);
        return;
      }
      this.dbService.dbService
        .saveToDB({
          _id: key,
          _rev: key,
          content: data,
          params: args
        })
        .then((doc: any) => {
          resolve("保存成功");
        })
        .catch((e: any) => {
          console.error(e);
          reject(e);
        });
    });
  }
}

export default CalendarController;
